import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGoogleDriveCustomerFilesResponse } from "../../api/googleDrive/index.types";

export interface IFundedTraderFilesState {
  isLoading: boolean;
  listOfUploadedFiles: IGoogleDriveCustomerFilesResponse["data"]["listOfUploadedFiles"];
}

const initialState: IFundedTraderFilesState = {
  isLoading: false,
  listOfUploadedFiles: [],
};

const fundedTraderFilesSlice = createSlice({
  name: "fundedTraderFiles",
  initialState,
  reducers: {
    fetchFilesRequest: (state) => {
      state.isLoading = true;
    },
    fetchFilesSuccess: (
      state,
      action: PayloadAction<IGoogleDriveCustomerFilesResponse["data"]>
    ) => {
      state.isLoading = false;
      state.listOfUploadedFiles = action.payload.listOfUploadedFiles;
    },
    fetchFilesFailed: (state) => {
      state.isLoading = false;
    },
  },
});

export const fundedTraderFilesActions = fundedTraderFilesSlice.actions;
export default fundedTraderFilesSlice.reducer;
